import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';
import { FORM_VALIDATION_ERRORS } from 'src/consts';

const initialValues = () => ({
  doctorName: '',
  email: '',
  zipCode: '',
  specialty: '',
});

const schema = Yup.object().shape({
  doctorName: Yup.string().required(FORM_VALIDATION_ERRORS.doctorName),
  email: capsuleValidation.email('Invalid email address.'),
  zipCode: capsuleValidation.zip().required(FORM_VALIDATION_ERRORS.zip),
  /** No numbers allowed */
  specialty: Yup.string()
    .matches(/^([^0-9]*)$/, FORM_VALIDATION_ERRORS.specialty)
    .required(FORM_VALIDATION_ERRORS.specialty),
});

const validation = {
  initialValues,
  schema,
};

export default validation;
